module.exports = __webpack_public_path__ + "img/kjd_logo@2x.80328aed.png";